import React, { useState, useEffect } from "react";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import Avatar from "components/Avatar";
import { useUserContext } from "store/contexts/userContext";
import * as moment from "moment";
import Scrollbar from "react-scrollbars-custom";
import Button from "components/CustomButton";
import { CSSTransition } from "react-transition-group";
import { usePopperTooltip } from "react-popper-tooltip";
import "react-popper-tooltip/dist/styles.css";
import { useToasts } from "react-toast-notifications";
import { useHistory } from "react-router-dom";

const styles = {
  responsesContainer: {
    height: "30px",
    width: "30px",
    borderRadius: "50%",
    background: "#ccc",
    display: "flex",
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.5rem",
  },
  responsesDetailsContainer: {
    minWidth: "100px",
    maxWidth: "170px",
    minHeight: "80px",
    maxHeight: "300px",
    height: "300px",
    width: "170px",
    overflow: "hidden",
    left: "unset",
    pointerEvents: "all",
    right: "10px",
    background: "white",
    zIndex: 1,
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  },
  responsesListContainer: {},
  responseContainer: {
    display: "flex",
    minHeight: "50px",
    padding: "0.25rem 1rem",
    alignItems: "center",
    borderBottom: "1px solid #ccc",
  },
  detailsSection: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    fontSize: "12px",
    padding: "4px",
    lineHeight: "14px",
  },
  remindButton: {
    background: "linear-gradient(to right, #FFA100 50%, #FFC42F, #FFE75E)",
    color: "black",
    fontSize: "13px",
    padding: "5px",
    height: "unset",
  },
  responseAwaits: {
    fontSize: "11px",
    fontWeight: 400,
  },
  userName: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "81px",
    fontSize: "13px",
    fontWeight: 500,
  },
  notRespond: {
    fontSize: "11px",
    fontWeight: 400,
    color: "red",
  },
  responsesContent: {
    display: "flex",
    justifyContent: "flex-end",
  },
  boxShadow: {
    boxShadow: "none",
    border: "none",
    position: "absolute",
    width: "100%",
  },
};

export default ({ slideShow, publish }) => {
  const classes = styles;
  let history = useHistory();
  const [controlledVisible, setControlledVisible] = useState(false);
  const [responsesData, setResponsesData] = useState(null);
  const [remindPerson, setRemindPerson] = useState();
  const [published, setPublished] = useState();
  const [disableReminder, setDisableReminder] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useUserContext();
  const { addToast } = useToasts();
  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef } =
    usePopperTooltip({
      trigger: "click",
      visible: controlledVisible,
      onVisibleChange: setControlledVisible,
      closeOnOutsideClick: true,
      closeOnTriggerHidden: false,
      placement: "auto-end",
      interactive: false,
    });

  useEffect(() => {
    setPublished(publish ?? slideShow.published);
  }, [publish, slideShow]);

  const showResponsesPooper = (event) => {
    if (!responsesData) {
      setLoading(true);
      getVideoResponseDetails();
    }
  };

  const getVideoResponseDetails = async () => {
    try {
      const response = await TeamService.getSlideShowResponse(
        slideShow.team_id,
        slideShow.post_id
      );
      setResponsesData(response?.data?.data?.members);
      // setResponsesData(response?.data?.data?.members.filter(members=>members.responded_at !== null));
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const postRemind = async (user) => {
    try {
      await TeamService.postRemindSlideshow(
        slideShow?.team_id,
        slideShow?.id,
        user?.id
      );

      setRemindPerson(user);
      addToast(`Reminder send successfully to ${user?.full_name}`, {
        appearance: "success",
      });
      setDisableReminder(true);
    } catch (e) {
      console.log(e);
    }
  };

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <div
      onMouseEnter={showResponsesPooper}
      onClick={showResponsesPooper}
      style={classes.relative}
    >
      <div style={classes.responsesContent}>
        <span className={"responseName"} ref={setTriggerRef}>
          R
        </span>
      </div>
      <CSSTransition
        in={Boolean(controlledVisible)}
        timeout={300}
        unmountOnExit
        classNames="popper-element"
      >
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container" })}
          style={classes.boxShadow}
        >
          <div
            {...getArrowProps({ className: "tooltip-arrow" })}
            data-popper-placement="left"
            data-popper-arrow="false"
            style={classes.responsesDetailsContainer}
          >
            <Scrollbar>
              <div style={classes.responsesListContainer}>
                {loading && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Loader />
                  </div>
                )}
                {responsesData &&
                  responsesData.map((response) => (
                    <div
                      key={response?.id}
                      elevation={3}
                      style={classes.responseContainer}
                    >
                      <Avatar
                        onClick={() => showUserProfile(response?.id)}
                        src={response?.avatar}
                        style={{
                          cursor: "pointer",
                          borderRadius: "50%",
                          height: "35px",
                          width: "35px",
                        }}
                      />
                      <div style={classes.detailsSection}>
                        <span style={classes.userName}>
                          {response?.id === user?.id
                            ? "You"
                            : response?.full_name}
                        </span>
                        {published && !response?.responded_at && (
                          <span style={classes.notRespond}>Not Responded</span>
                        )}
                        {!response?.responded_at && !published && (
                          <span style={classes.responseAwaits}>
                            Response Awaits
                          </span>
                        )}
                        <span
                          style={{
                            color: "green",
                          }}
                        >
                          {!!response?.responded_at && <b>Responded</b>}
                          {!response?.responded_at && !published && (
                            <div>
                              <Button
                                disabled={
                                  remindPerson &&
                                  remindPerson?.id === response?.id &&
                                  disableReminder &&
                                  true
                                }
                                buttonClass={"grad_btn"}
                                onClick={() => postRemind(response)}
                                buttonStyle={classes.remindButton}
                                size="sm"
                              >
                                Remind
                              </Button>
                            </div>
                          )}
                        </span>
                        <span>
                          {!!response?.responded_at &&
                            moment(response?.responded_at).format(
                              "MMM DD, YYYY"
                            )}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </Scrollbar>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};
